import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "tabInput"]
  static classes = ["active", "inactive"]
  static values = {active: { type: String }}

  static outlets = ["missions-calendar"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    const activeTabName = params.get("tab")

    let index = this.tabTargets.findIndex(tab => tab.dataset.tabsNameParam === activeTabName)
    if (index === -1) {
      index = this.tabTargets.findIndex(tab => tab.dataset.tabsNameParam === this.activeValue)
    }
    if (index === -1) index = 0

    this.showTab(index)
  }

  change(event) {
    const name = event.params.name
    const index = this.tabTargets.findIndex(tab => tab.dataset.tabsNameParam === name)

    this.showTab(index)
    this.updateURL(name)
  }

  showTab(index) {
    let currentTabName = ""
    this.panelTargets.forEach((panel, i) => {
      const isCurrent = i === index
      panel.classList.toggle("hidden", !isCurrent)

      const tab = this.tabTargets[i]
      if (!tab) return;

      if (isCurrent) {
        tab.classList.add(...this.activeClasses)
        tab.classList.remove(...this.inactiveClasses)
        currentTabName = tab.dataset.tabsNameParam
      } else {
        tab.classList.remove(...this.activeClasses)
        tab.classList.add(...this.inactiveClasses)
      }
    })

    if (this.hasTabInputTarget && currentTabName) {
      this.tabInputTarget.value = currentTabName
    }

    if (this.hasMissionsCalendarOutlet) {
      setTimeout(() => {
        this.missionsCalendarOutlet.resize()
      }, 0)
    }
  }

  updateURL(name) {
    const url = new URL(window.location)
    url.searchParams.set("tab", name)
    window.history.replaceState({}, "", url)
  }
}
